define(["require", "exports", "tslib", "@sentry/browser", "@sentry/tracing"], function (require, exports, tslib_1, Sentry, tracing_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.errorReporting = void 0;
    Sentry = (0, tslib_1.__importStar)(Sentry);
    var reportErrors = function (_a) {
        var projectName = _a.projectName, releaseVersion = _a.releaseVersion, tracingOrigins = _a.tracingOrigins, extra = _a.extra;
        if (window._env_.SENTRY_API_KEY) {
            Sentry.init((0, tslib_1.__assign)({ dsn: window._env_.SENTRY_API_KEY, release: projectName + "@" + (releaseVersion || process.env.npm_package_version), integrations: [
                    tracingOrigins
                        ? new tracing_1.Integrations.BrowserTracing({
                            tracingOrigins: tracingOrigins,
                        })
                        : new tracing_1.Integrations.BrowserTracing(),
                ], tracesSampleRate: 1.0 }, (extra ? extra : {})));
        }
    };
    exports.errorReporting = { reportErrors: reportErrors };
});
//# sourceMappingURL=index.js.map